module.exports = __webpack_public_path__ + "img/ring_skip_0_0_0@3x.36dacfea.png";